export default __webpack_public_path__ + "static/media/Nav-Registration.20e28578.svg";